<div class="modal-header">
  <h3 class="modal-title" i18n="@@hotelPhotos">Hotel Photos</h3>
  <button
    type="button"
    class="light-icon-button close"
    aria-label="Close"
    (click)="activeModal.close(false)"
    ngbAutoFocus
  >
    <i class="ico-cancel AA-standard-grey" aria-hidden="true"></i>
  </button>
</div>
<div class="modal-body">
  @if (hotelImages?.length && !loading) {
    <div
      id="hotel-gallery-images"
      class="hotel-gallery"
      [ngClass]="{ visuallyhidden: imagesLoaded < hotelImages.length }"
    >
      @for (image of hotelImages; track image; let index = $index) {
        <div
          [ngClass]="{ 'highlighted-hotel': image === selectedHotel }"
          (click)="selectedHotel = image"
          (keydown.enter)="selectedHotel = image"
          tabindex="0"
          role="button"
          [attr.aria-pressed]="image === selectedHotel"
        >
          <img [src]="image" alt="Photo {{ index }}" (load)="imagesLoadedCount()" />
        </div>
      }
    </div>
    @if (selectedHotel) {
      <div
        id="hotel-gallery-selected"
        class="selected-image"
        [ngClass]="{ visuallyhidden: imagesLoaded < hotelImages.length }"
      >
        <img [src]="selectedHotel" alt="Selected hotel image" />
      </div>
    }
    @if (imagesLoaded < hotelImages.length) {
      <div>
        <app-loading-spinner size="sm" />
      </div>
    }
  }

  @if (!hotelImages?.length && loading) {
    <div>
      <app-loading-spinner size="sm" />
    </div>
  }
  @if (!hotelImages?.length && !loading) {
    <div i18n="@@noPhotos">No photos...</div>
  }
</div>
